import { all } from "redux-saga/effects";

import LoginSaga from "./Redux/Saga/LoginSaga";
import ForgotPasswordSaga from "./Redux/Saga/ForgotPasswordSaga";
import OtpSaga from "./Redux/Saga/OtpSaga";
import ThemeSaga from "./Redux/Saga/ThemeSaga";
import GetUserSaga from "./Redux/Saga/UserSaga";
import GetBankSaga from "./Redux/Saga/BankSaga";
import HomeSaga from "./Redux/Saga/HomeSaga";
import ZipSaga from "./Redux/Saga/ZipSaga";
import ProductSaga from "./Redux/Saga/ProductSaga";
import VideosSaga from "./Redux/Saga/VideosSaga";
import AdminSaga from "./Redux/Saga/AdminSaga";
import MobileConfigurationSaga from "./Redux/Saga/mobileConfigurationSaga";
import ContactUsSaga from "./Redux/Saga/ContactUsSaga";
import QuestionSaga from "./Redux/Saga/QuestionSaga";
import ServicesSaga from "./Redux/Saga/ServicesSaga";
import SettingsSaga from "./Redux/Saga/SettingsSaga";
import HelpSaga from "./Redux/Saga/HelpSaga";
import ServiceRequestSaga from "./Redux/Saga/ServiceRequestSaga";
import ChangePasswordSaga from "./Redux/Saga/ChangePasswordSaga";
import UpdatePasswordSaga from "./Redux/Saga/UpdatePasswordSaga";
import RegistrationSaga from "./Redux/Saga/SignupSaga";
import GetHolidaySaga from "./Redux/Saga/HolidaySaga";
import GetAnnouncementSaga from "./Redux/Saga/AnnouncementSaga";

export default function* rootSaga(getState) {
  yield all([
    LoginSaga(),
    ForgotPasswordSaga(),
    OtpSaga(),
    ThemeSaga(),
    GetUserSaga(),
    GetBankSaga(),
    GetHolidaySaga(),
    GetAnnouncementSaga(),
    HomeSaga(),
    ZipSaga(),
    ProductSaga(),
    VideosSaga(),
    AdminSaga(),
    MobileConfigurationSaga(),
    ContactUsSaga(),
    QuestionSaga(),
    ServicesSaga(),
    SettingsSaga(),
    HelpSaga(),
    ServiceRequestSaga(),
    ChangePasswordSaga(),
    UpdatePasswordSaga(),
    RegistrationSaga(),
  ]);
}
